<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入发货信息</span>
    </template>
    <template #content>
      <gj-upload
          template-url="/supply/storageCostBatch/download/ship/supplement/template"
          container-type="application/x-www-form-urlencoded"
          @uploadAfter="uploadAfter"
          style="margin-bottom: 10px;"
      ></gj-upload>
      <gj-import-alert
          :rules="[
            '支持导入格式为xls/xlsx的文件',
            '导入后将根据FBA收货情况生成批次，并在批次管理系统自动进行重算',
            '财务-利润报表、分析-利润统计需要手动重算',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "@/minxins";
  import { storageCostBatchImportShipSupplement } from "@/api/finance";

  export default {
    name: "ImportBatch",
    mixins: [modalMixIn, uploadMixin],
    props: {
      hideMskuList: {
        default: () => []
      },
    },
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      // 上传成功后的回调
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        storageCostBatchImportShipSupplement(attId)
          .then((res) => {
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      }
    }
  }
</script>

<style scoped>

</style>











s